export default {
  // Chưa xác định
  Undentify: 0,

  // Có giảm thuế
  DecreasingTaxRate: 1,

  // Không giảm thuế
  NoneDecreasingTaxRate: 2
};
